import React from "react";
import StatusBar from "../../preapps/StatusBar";
const PreappStatusBar = ({ status2Percentage, t }) => {
    return (
        <div className="table-div-td col-status col-status-hover">
            {t[1].progression_id > -1 && t[1].progression_id <= 6 ? (
                <StatusBar
                    currentStatus={
                        t[1].progression ? t[1].progression.status : ""
                    }
                    className="col-status-bar"
                    style={{ maxWidth: "65px" }}
                    percentage={status2Percentage}
                />
            ) : t[1].progression_id === 19 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#7f7f7f" }}
                    />
                    <p title="Pending Prevet">Pending Prevet</p>
                </div>
            ) : t[1].progression_id === 20 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#e6e612" }}
                    />
                    <p title="Pending Prevet">Approved Prevet</p>
                </div>
            ) : t[1].progression_id === 7 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#F0BE74" }}
                    />
                    <p title="Sent for Signature">Sent for Signature</p>
                </div>
            ) : t[1].progression_id === 8 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#819FEC" }}
                    />
                    <p title="Pre-Bank Review">Signed-PC Review</p>
                </div>
            ) : t[1].progression_id === 9 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#7FCECE" }}
                    />
                    <p title="Underwritting">UW Review</p>
                </div>
            ) : t[1].progression_id === 10 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#E7B8DF" }}
                    />
                    <p title="Underwritting pending">Pended</p>
                </div>
            ) : t[1].progression_id === 11 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title="Awaiting Reserve">Reserve Req</p>
                </div>
            ) : t[1].progression_id === 12 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title="Approved">Approved</p>
                </div>
            ) : t[1].progression_id === 13 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#FFA500" }}
                    />
                    <p title="Declined">Declined</p>
                </div>
            ) : t[1].progression_id === 14 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#660000" }}
                    />
                    <p title="Cancelled">Cancelled</p>
                </div>
            ) : t[1].progression_id === 15 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title="App pending PC approval">
                        App pending PC approval
                    </p>
                </div>
            ) : t[1].progression_id === 16 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#F0BE74" }}
                    />
                    <p title="Sent for Signature">Sent for Signature</p>
                </div>
            ) : t[1].progression_id === 17 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#F0BE74" }}
                    />
                    <p title="PDF requested">PDF requested</p>
                </div>
            ) : t[1].progression_id === 21 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#FF0000" }}
                    />
                    <p title="Terminated">Terminated</p>
                </div>
            ) : t[1].progression_id === 22 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#0000FF" }}
                    />
                    <p title="Support">Support</p>
                </div>
            ) : (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title="Awaiting wet signature">Awaiting wet signature</p>
                </div>
            )}
        </div>
    );
};

export default PreappStatusBar;
